export const freezeBody = (doFreeze, scrollToTop = true) => {
  const body = document.body;

  const scrollbarWidth = getScrollBarWidth();

  body.classList.toggle('_freeze', doFreeze);

  if (doFreeze) {
    body.style.top = `-${window.scrollY}px`;

    body.style.position = 'fixed';
  } else {
    const top = window.getComputedStyle(body).top;

    const scrollToY = parseInt(top || '0') * -1;

    body.removeAttribute('style');

    if(scrollToTop) window.scrollTo(0, scrollToY);
  }
};

export const getScrollBarWidth = () => {
  const outer = document.createElement('div');

  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar';

  document.body.appendChild(outer);

  const inner = document.createElement('div');

  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
};
